export const BILL_TIMEOUT_ERROR = {
    title: "Restaurant is taking longer than usual to generate bill",
    message: "You can wait or ask the waiter directly to get the bill",
    imgUrl: "https://media-assets.swiggy.com/portal/static-assets/images/digital-menu/all-theme-assets/generate_bill_timeout.png",
    isPollingTimedOut: true,
};

export const BILL_DOWNLOAD = {
    SUCCESS: "Bill downloaded successfully! Swiggy isn’t responsible for any discrepancies",
    ERROR: "Failed to download bill, Please try again!",
    AUTO_DISMISS_TIME: 4000, //4 seconds
};

export const BILL_RETRY = {
    SUCCESS: "We have reminded the restaurant again",
    ERROR: "Failed to retry bill, Please try again !",
};

export const DEEPLINK_FORMAT = `swiggy://webviewV2?payment_plugin=true&pushScreen=true&darkTheme={0}&is_fullscreen={1}&webview_url={2}`;

export const MARKETPLACE_HEADERS = {
    BUSINESS_LINE: "dineout",
    MARKETPLACE_CATEGORY: "dining",
    X_WEB_CHECKOUT_FLOW: "dineoutcart",
    BUSINESS_LINE_ID: "DINEOUT",
};

export const DEFAULT_ERROR_CODE = "1";
export const DEFAULT_ERROR_MESSAGE = "Received error while {0} order";
